// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"73985028","453":"f4d4ecbe","796":"157e2658"}[chunkId] + ".chunk.js";
};